import { NgModule } from '@angular/core';
import { AeAuthService } from '@extranet/services/auth-service';
import { ExtraOptions, PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { IsProspectLogged } from './guards/is-prospect-logged.guard';
import { IsProspectNotLogged } from './guards/is-prospect-not-logged.guard';

const routerOptions: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  anchorScrolling: 'enabled',
  onSameUrlNavigation: 'reload',
  paramsInheritanceStrategy: 'always'
};

const routes: Routes = [
  {
    path: 'app',
    canActivate: [IsProspectLogged],
    loadChildren: () => import('@extranet/components/logged').then(m => m.AeLoggedModule)
  },
  {
    path: 'auth',
    canActivate: [IsProspectNotLogged],
    loadChildren: () => import('@extranet/components/auth').then(m => m.AeAuthModule)
  },
  {
    path: '**',
    redirectTo: 'app',
    pathMatch: 'prefix'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private authService: AeAuthService) {
    this.authService.getLoginStorage();
  }
}
